module.exports = __webpack_public_path__ + "static/media/W5390484_12.71a52a4a.jpg";